import React, { Component } from 'react'
import { TICKETS_QUERY, UPDATE_TICKET_QUERY } from "../../queries/Queries"
import { IconButton } from '@mui/material';
import { FaLockOpen, FaLock, FaSortUp, FaSortDown } from "react-icons/fa";
import { useMutation, useQuery } from '@apollo/react-hooks';
import CircularProgressIndicator from '../elements/CircularProgressIndicator';
import { FaSave } from "react-icons/fa";
import Ticket from './Ticket';
import { AUTH_TOKEN } from '../../constants';
import { flattenStrapiData } from '../../utils/utilities';

class TicketList extends Component {
  state = {
    locked: true,
    error: "",
    columns: [
        {column: "id", direction: "asc"},
        {column: "type", direction: "asc"},
        {column: "message", direction: undefined},
        {column: "client info", direction: undefined},
        {column: "created at", direction: "asc"},
        {column: "creator", direction: "asc"},
        {column: "state", direction: "asc"},
        {column: "updated at", direction: "asc"},
    ],
    sortBy: "id:asc"
  }

  handleLockChange(e) {
    this.setState({locked: !this.state.locked});
  }

  updateColumn(at) {
    let column = this.state.columns[at]

    if(column.direction === undefined)
        return;

    column.direction = column.direction === 'asc' ? 'desc' : 'asc'
    let columns = this.state.columns
    columns[at] = column
    let sortBy =  column.column + ":" + column.direction
    this.setState({columns: columns, sortBy: sortBy})
  }

  render() {
    const token = localStorage.getItem(AUTH_TOKEN)
    if(!token) {
      return(
        <div>
          <span className="Error">You must be loged in first</span>
        </div>
      )
    }

    return (
      <div>
          <IconButton onClick={this.handleLockChange.bind(this)} >{this.state.locked ? <FaLock/> : <FaLockOpen/> }</IconButton>
          <div><span className="error">{this.state.error}</span></div>
          <br/>
          <GetList
            token={token} 
            locked={this.state.locked}
            updateColumn={this.updateColumn.bind(this)}
            columns={this.state.columns}
            sortBy={this.state.sortBy}
          />
      </div>
    )
  }
}

function GetList({locked, token, updateColumn, columns, sortBy}) {
  const {data, loading, error, refetch} = useQuery(TICKETS_QUERY, {variables: {sortBy: sortBy}})
  
  if(loading) return(<CircularProgressIndicator size={60} />)
  if(error) return(<span className="error">{error.message}</span>)
  
  function sort(columnNumber) {
    updateColumn(columnNumber)
    refetch({variables: {sortBy: sortBy}})
  }

  function getArrow(direction) {
    return direction === "asc" ? <FaSortUp/> : <FaSortDown/>
  }

  function getColumnHeader(index) {
      return <th onClick={columns[index].direction !== undefined ? () => sort(index) : () => {}}><div><h4>{columns[index].column}</h4>{columns[index].direction !== undefined ? getArrow(columns[index].direction) : ""}</div></th>;
  }

  let tickets = data?.tickets?.data
  return (
    <table className="table table-bordered">
      <thead>
        <tr>
            {getColumnHeader(0)}
            {getColumnHeader(1)}
            {getColumnHeader(2)}
            {getColumnHeader(3)}
            {getColumnHeader(4)}
            {getColumnHeader(5)}
            {getColumnHeader(6)}
            {getColumnHeader(7)}
          {token && !locked &&
          <th><h4>Edit/Add</h4></th>}
        </tr>
      </thead>
      <tbody>
        {tickets.map(ticket => {
          ticket = flattenStrapiData(ticket)
          return <Ticket 
          key={ticket.id} 
          locked={locked} 
          ticket={ticket}>
            <Update refetch={() => refetch()}/>
          </Ticket>
        })}
      </tbody>
    </table>
  )
}

function Update({id, state, refetch}) {
  const [updateTicket, {loading, error}] = useMutation(UPDATE_TICKET_QUERY)

  if(loading) return(<CircularProgressIndicator size={60} />)
  if(error) alert("Update Mutation Error: "+ error.message)
  return (
      <IconButton onClick={e => updateTicket({variables: {id: id, state: state.state}})
      .then(data => refetch())
      .catch(e => alert("Execute Update Mutation Error: "+e))}><FaSave/></IconButton>
  )
}


export default TicketList